<template>
  <card>
    <b-row align-v="center" slot="header" >
      <b-col cols="8">
        <h3 class="mb-0">Edit profile </h3>
      </b-col>
      <!-- <b-col cols="4" class="text-right">
        <a href="#!" class="btn btn-sm btn-primary">Settings</a>
      </b-col> -->
    </b-row>

    <b-form @submit.prevent="updateProfile">
      <h6 class="heading-small text-muted mb-4">User information</h6>

      <div class="pl-lg-4">
        <b-row>
          <b-col lg="6">
            <base-input
              type="text"
              label="Name"
              placeholder="Name"
              v-model="model.name"
            >
            </base-input>
          </b-col>
          <b-col lg="6">
            <base-input
              type="text"
              label="Last name"
              placeholder="Last name"
              v-model="model.lastName"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row >
          <b-col lg="6">
            <base-input
              type="email"
              label="Email"
              placeholder="email"
              v-model="model.email"
              disabled
            >
            </base-input>
          </b-col>
          <b-col lg="6">
            <base-input
              type="phone"
              label="Phone"
              placeholder="Phone"
              v-model="model.phone"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>
      <!-- <hr class="my-4"> -->

      <!-- Address -->
      <!-- <h6 class="heading-small text-muted mb-4">Contact information</h6>

      <div class="pl-lg-4">
        <b-row>
          <b-col md="12">
            <base-input
              type="text"
              label="Address"
              placeholder="Home Address"
              v-model="user.address"
            >
            </base-input>
          </b-col>
        </b-row>
        <b-row>
          <b-col lg="4">
            <base-input
              type="text"
              label="City"
              placeholder="City"
              v-model="user.city"
            >
            </base-input>
          </b-col>
          <b-col lg="4">
            <base-input
              type="text"
              label="Country"
              placeholder="Country"
              v-model="user.country"
            >
            </base-input>
          </b-col>
          <b-col lg="4">
            <base-input
              label="Postal Code"
              placeholder="ZIP Code"
              v-model="user.postalCode"
            >
            </base-input>
          </b-col>
        </b-row>
      </div>

      <hr class="my-4"> -->
      <!-- Description -->
      <!-- <h6 class="heading-small text-muted mb-4">About me</h6>
      <div class="pl-lg-4">
        <b-form-group label="About Me" label-class="form-control-label" class="mb-0" label-for="about-form-textaria"> -->
         <!--  <label class="form-control-label">About Me</label> -->
          <!-- <b-form-textarea rows="4" value="A beautiful premium dashboard for BootstrapVue." id="about-form-textaria" placeholder="A few words about you ..."></b-form-textarea>
        </b-form-group>
      </div> -->
      <b-row>
        <b-col class="text-right">
          <base-button type="primary" native-type="submit" class="my-4" :disabled="!hasChanges">Save</base-button>
        </b-col>
      </b-row>
    </b-form>
  </card>
</template>
<script>
import { mapGetters } from 'vuex';
import AuthService from '../../../services/auth.service';
export default {
  data() {
    return {
      model: {}
    };
  },
  methods: {
    async updateProfile() {
      await AuthService.edit(this.model)
    }
  },
  computed: {
    ...mapGetters({
      user: 'user/user'
    }),
    hasChanges () {
      let changes = 0
      Object.keys(this.model).forEach(key => {
        if (this.user[key] !== this.model[key]) {
          changes++
        }
      })
      return !!(changes)
    }
  },
  mounted() {
    this.model = {
      name: this.user.name,
      lastName: this.user.lastName,
      email: this.user.email,
      phone: this.user.phone
    }
  }
};
</script>
<style></style>
